import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@as/cotopaxi';
export const MiniPDPTitle = ({ productBrand, productTitle }) => (_jsxs(Text, { lineClamp: 1, children: [_jsx(Text, { emphasized: true, inline: true, children: productBrand }), ` ${productTitle}`] }));
